{
  "ts": 1748849776,
  "tsCommit": 1748438575,
  "repoName": "NCApp3",
  "branchName": "prod",
  "rev": "eb2021b",
  "ver": "20250602_0736_NCApp3_prod_eb2021b",
  "env": "production",
  "appVer": "5.5.0",
  "isBranchDeployment": false,
  "e2eApiHostUrl": "https://api-master.naturalcycles.com"
}
